import '../../../Modals/XpektorBootstrapModal.scss';
import { Modal } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import UserService from '../../../../../Services/UserService';
import validateSettingsForm from '../../validateSettingsForm';
import XpektorButton from '../../../../../Components/XpektorButton/XpektorButton';

/* eslint-disable react/prop-types */
function UpdateUserModal({ handleClose, selectedUser, onUpdated }) {
  let userErrors;
  const formNumber = 3;
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState({});

  useEffect(() => {
    setUser({
      id: selectedUser?.id,
      customerId: selectedUser.customerId,
      name: selectedUser?.name,
      email: selectedUser?.email,
      role: selectedUser?.role,
    });
  }, []);

  const handleSubmit = async () => {
    if (Object.keys(errors).length > 0) {
      alert('Det finns fel i formuläret');
    } else {
      await UserService.UpdateUser(user)
        .then(async () => {
          await onUpdated();
          handleClose();
        })
        .catch((error) => {
          if (error.response.status === 404) {
            alert('Kunde inte ändra användare');
          }
          if (error.response.status === 403) {
            alert('Du har ej behörighet att ändra användare');
          }
          if (error.response.status === 500) {
            alert('Något gick fel, försök igen senare');
          }
        });
    }
  };

  const handleChange = (e, set) => {
    userErrors = validateSettingsForm(formNumber, set, e.target.value);
    setErrors(userErrors);

    const newValue =
      e.target.name === 'role' ? Number(e.target.value) : e.target.value;
    setUser((prevState) => ({
      ...prevState,
      [e.target.name]: newValue,
    }));
  };

  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      className="border-0 xpektor-bootstrap-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Ändra användare</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <TextField
              variant="outlined"
              label="För & Efternamn"
              type="text"
              name="name"
              placeholder={user.name}
              onChange={(e) => handleChange(e, 1)}
              value={user.name}
              error={errors.newUserName}
              helperText={errors.newUserName}
              className="w-100"
            />
          </Form.Group>
          <br />
          <Form.Group>
            <TextField
              variant="outlined"
              label="Email"
              type="text"
              name="email"
              placeholder={user.email}
              onChange={(e) => handleChange(e, 2)}
              value={user.email}
              error={errors.newEmail}
              helperText={errors.newEmail}
              className="w-100"
            />
          </Form.Group>
          <br />
          <Form.Group>
            <select
              name="role"
              className="form-select"
              onChange={(e) => handleChange(e)}
            >
              <option value={0} selected={user?.role === 0}>
                Användare
              </option>
              <option value={1} selected={user?.role === 1}>
                Admin
              </option>
            </select>
          </Form.Group>
        </Form>
        <div className="confirm-row">
          <XpektorButton content="Ändra användare" onClick={handleSubmit} />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default UpdateUserModal;
